(function(scope){
function pack(rects){
  const orders=[rects.slice().sort((a,b)=>b.w*b.h-a.w*a.h),rects.slice().sort((a,b)=>Math.max(b.w,b.h)-Math.max(a.w,a.h))];
  let best=null;
  for(const order of orders){
    const sheets=[];let feasible=true;
    for(const piece of order){
      let candidate=null;
      for(let s=0;s<=sheets.length;s++){
        const spaces=s<sheets.length?sheets[s].free:[{x:0,y:0,w:1480,h:2980}];
        spaces.forEach((space,i)=>{
          for(const rotate of [false,true]){
            const w=(rotate?piece.h:piece.w)+5,h=(rotate?piece.w:piece.h)+5;
            if(w<=space.w&&h<=space.h){const score=(s===sheets.length?1e9:0)+space.w*space.h-w*h;
              if(!candidate||score<candidate.score)candidate={s,i,w,h,score,space};}
          }
        });
      }
      if(!candidate){feasible=false;break;}
      const c=candidate;
      if(c.s===sheets.length)sheets.push({free:[{x:0,y:0,w:1480,h:2980}],placed:[]});
      const sheet=sheets[c.s],space=sheet.free.splice(c.i,1)[0];
      sheet.placed.push({name:piece.name,x:space.x,y:space.y,w:c.w-5,h:c.h-5});
      const right={x:space.x+c.w,y:space.y,w:space.w-c.w,h:c.h};
      const bottom={x:space.x,y:space.y+c.h,w:space.w,h:space.h-c.h};
      if(right.w>0)sheet.free.push(right);if(bottom.h>0)sheet.free.push(bottom);
    }
    if(feasible&&(!best||sheets.length<best.length))best=sheets;
  }
  return best;
}
function estimate({length,width,height,bottom=true,wheels=false,quantity=1}){
  if(![length,width,height,quantity].every(Number.isFinite)||!Number.isInteger(quantity)||quantity<1||quantity>99)return null;
  const l=Math.max(length,width),w=Math.min(length,width),h=height;
  if(l<40||l>240||w<30||w>100||h<20||h>80)return null;
  const lm=l/100,wm=w/100,hm=h/100;
  const braceCount=l>=150?Math.max(1,Math.ceil(l/100)-1):0;
  const pieces=[{name:'long',w:l*10,h:h*10+150},{name:'long',w:l*10,h:h*10+150},{name:'short',w:w*10,h:h*10+150},{name:'short',w:w*10,h:h*10+150}];
  if(bottom)pieces.push({name:'bottom',w:l*10,h:w*10});
  for(let i=0;i<braceCount;i++)pieces.push({name:'brace-provisional',w:w*10,h:40});
  const sheets=pack(pieces);if(!sheets)return null;
  const sideArea=2*(lm+wm)*(hm+.15),bottomArea=bottom?lm*wm:0;
  const referenceHT=102.8360633748816+37.50736352808355*sideArea+9.808037071659307*2*(lm+wm)+(bottom?29.2971735485433*bottomArea+24.12254894238294:0);
  const theoreticalMaterial=(sideArea+bottomArea)*112/4.5;
  const customHT=referenceHT-theoreticalMaterial+sheets.length*112+25+braceCount*12+(wheels?50:0);
  const unitTTC=Math.ceil(customHT*1.2/5)*5;
  return {unitTTC,totalTTC:unitTTC*quantity,sheets:sheets.length,braceCount,placements:sheets};
}
scope.HaganePricing={estimate,pack};
if(typeof module!=='undefined'&&module.exports)module.exports=scope.HaganePricing;
})(typeof window!=='undefined'?window:globalThis);
